import { AssetType } from "../../../../types/AssetType";
import { DraftAssetType } from "../../../../types/DraftAssetType";

export enum NoteSource {
    CloudAsset = "CloudAsset",
    OnPremAsset = "OnPremAsset",
    CloudDraftAssetCloudFile = "CloudDraftAssetCloudFile",
    CloudDraftAssetFileRecord = "CloudDraftAssetFileRecord",
    OnPremDraftAssetFileRecord = "OnPremDraftAssetFileRecord"
}

export interface GetNotesByAsset {
    id: string;
    assetType?: AssetType;
    draftAssetType?: DraftAssetType;
}
